/*
window.console = console;
window.consoleBackup = window.console;

var console = {};
console.log = function(){ return null;};
console.dir = function(){ return null;};
console.info = function(){ return null;};
console.warn = function(){ return null;};
console.error = function(){ return null;};

var poplog = function(){ return null;};
var openpowindow = function(){ return null;};

*/
//alert = function(){};

var terminalWindow;
window.enableTerminal = false;
window.terminalWindowOpen = false;
window.terminalDebug = false;

document.addEventListener( 'keydown', function( e ) {
	//console.log(e.which);
	if ( e.ctrlKey && e.altKey && e.shiftKey && e.which == 84 ) { //"t"
		openTerminal();
	}
	if ( e.altKey && e.shiftKey && e.which == 80 ) { //"p"
		console.log("%c%s", "color: #55ff55; font-size:30px;","POTATO!!!!");
		if(document.getElementById('electric_love_potato') === null){
			console.log("adding script");
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.id = 'electric_love_potato';
			script.src = '/wp-content/themes/soledad-child/inc/electric_love_potato.js/electric_love_potato_js/electric_love_potato.js';    
			document.getElementsByTagName('head')[0].appendChild(script);
		}
		
		if(document.getElementById('_potato') === null){
			console.log("opening potato");
			setTimeout(function () {
				init_lovepotato('RANDOM');
			}, 100);
		}else{
			console.log("closing potato");
			window._quitpotato();
		}
	}
} );




var terminal = function( data, appendit ) {
	if ( window.enableTerminal ) {
		if ( typeof appendit === 'undefined' ) {
			appendit = true;
		}
		if ( typeof data === 'object' ) {
			var out = '';
			for ( var i in data ) {
				try {
					out += i + ': ' + data[ i ] + '<br>\n';
				} catch ( error ) {
					return;
				}
			}
			var cache = [];
			data = '<pre>' + JSON.stringify( data, function( key, value ) {
				if ( typeof value === 'object' && value !== null ) {
					if ( cache.indexOf( value ) !== -1 ) {
						// Duplicate reference found
						try {
							// If this value does not reference a parent it can be deduped
							return JSON.parse( JSON.stringify( value ) );
						} catch ( error ) {
							// discard key if value cannot be deduped
							return;
						}
					}
					// Store value in our collection
					cache.push( value );
				}
				return value;
			}, '\t' ) + '</pre>';
		}
		cache = null; // Enable garbage collection
		openpowindow();
		jQuery( document ).ready( function( $ ) {
			if ( typeof window.PopWindow === 'undefined' ) {
				openpowindow();
			}
			if ( appendit ) {
				$( window.PopWindow.document.body ).append( '<hr>' );
				$( window.PopWindow.document.body ).append( data );
			} else {
				$( window.PopWindow.document.body ).html( data );
			}
		} );
	}
};

var openTerminal = function() {
	if ( typeof window.terminalWindow === 'undefined' || ! $( window.terminalWindow ).length ) {
		window.terminalWindow = window.open( '/?terminal=yes', 'Terminal', 'width=500, height=500' );
		window.terminalWindowOpen = true;
		var pollTimer = window.setInterval( function() {
			if ( typeof window.terminalWindow === 'undefined' || window.terminalWindow == null ) {
				terminalWindowOpen = false;
			} else if ( window.terminalWindow.closed !== false ) { // !== is required for compatibility with Opera
				window.clearInterval( pollTimer );
				terminalWindowOpen = false;
				window.terminalWindow = '';
			}
		}, 200 );
	} else {
		return;
	}
	console.log( window.terminalWindow );
};

//alert("test");

